import { CtaOverlay as CtaOverlayComponent } from "./CtaOverlay.component";

export const CtaOverlay = CtaOverlayComponent;
